module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-26.086c3e41.png";